import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';

const SrInfoDropdown = ({
  isExpanded,
  title,
  description,
  onClick,
}) => {
  return (
    <SrBox
      width='100%'
      borderRadius='8px'
      padding='21px 24px 21px'
      boxSizing='border-box'
      position='relative'
      border='1px solid #E5E5E5'
      cursor='pointer'
      minHeight={isExpanded ? '164px' : null}
      onClick={onClick}
    >
      <SrFlex align='start' justify='between' width='100%' boxSizing='border-box'>
        <SrText
          color='blueNavy'
          font='greycliff'
          weight='600'
          size='18'
          lineHeight='28px'
          display='block'
          letterSpacing='0px'
        >
          {title}
        </SrText>
        <img
          src='/images/arrow-up-black.svg'
          alt='arrow icon'
          style={{
            transform: isExpanded ? null : 'scaleY(-1)',
            margin: '10px 0 0 16px',
          }}
        />
      </SrFlex>
      {isExpanded && (
        <SrBox marginTop='16px'>
          <SrText
            color='grey500'
            font='greycliff'
            weight='400'
            size='16'
            lineHeight='24px'
            display='block'
            letterSpacing='0px'
          >
            {description}
          </SrText>
        </SrBox>
      )}
    </SrBox>
  );
};

SrInfoDropdown.propTypes = {
  isExpanded: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

SrInfoDropdown.defaultProps = {
  isExpanded: true,
};

SrInfoDropdown.displayName = 'SrInfoDropdown';

export default SrInfoDropdown;
